import { render, staticRenderFns } from "./BindSuccess.vue?vue&type=template&id=1b3813cc&scoped=true&lang=pug&"
import script from "./BindSuccess.vue?vue&type=script&lang=js&"
export * from "./BindSuccess.vue?vue&type=script&lang=js&"
import style0 from "./BindSuccess.vue?vue&type=style&index=0&id=1b3813cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3813cc",
  null
  
)

export default component.exports